import { Injectable } from '@angular/core';
import {HttpServiceBase, Page} from '../core/services/HttpServiceBase';
import {DTO, Edition, PriceRule, ProductDetail, Rarity} from '../core/entities/entities';
import {HttpService} from '../core/services/http.service';
import {LanguageService} from './language.service';
import {CardConditionService} from './card-condition.service';
import {isNullOrUndefined} from 'util';
import {Observable} from 'rxjs/Observable';
import * as Rx from 'rxjs/Rx';
import {ErrorType} from '../core/services/error.service';
import {Response} from '@angular/http';
import {isNumeric} from 'rxjs/util/isNumeric';
import {RarityService} from './rarity.service';
import {HoloService} from './holo.service';

export class PriceRuleDetailDTO {
  id: any;
  modifiedDate?: Date;
  modifiedBy?: string;
  altered: boolean;
  conditionId: any[] = [];
  cardId: any;
  categoryId: any;
  brandId: any;
  holo: any;
  editionId: any [] = [];
  firstEdition: boolean;
  shadowless: boolean;
  staff: boolean;
  foil: boolean;
  hot: boolean;
  inked: boolean;
  languageId: any[] = [];
  price: number;
  minRule?: boolean;
  maxRule?: boolean;
  maxPrice?: number;
  rarityId: any [] = [];
  signed: boolean;
  stamped: boolean;
  editions: Edition[] = [];
}

@Injectable()
export class PriceRuleService extends HttpServiceBase<PriceRule> {
  getUrl(): string {
    return 'priceRules/multiple';
  }

  protected init(): void {
  }

  getCleanInstance(): PriceRule {
    return new PriceRule();
  }


  getDTOfromRule( rule: PriceRule){
    const dto: PriceRuleDetailDTO = new PriceRuleDetailDTO();
    dto.id = rule.id;
    dto.modifiedDate = rule.modifiedDate;
    dto.modifiedBy = rule.modifiedBy;
    dto.cardId = rule.product ? rule.product.id : null;
    dto.firstEdition = rule.combination.firstEdition;
    dto.shadowless = rule.combination.shadowless;
    dto.staff = rule.combination.staff;
    dto.altered = rule.combination.altered;
    dto.signed = rule.combination.signed;
    dto.stamped = rule.combination.stamped;
    dto.inked = rule.combination.inked;
    dto.foil = rule.combination.foil;
    dto.price = rule.price;
    dto.holo = rule.combination.holo ? rule.combination.holo.id : null;

    dto.minRule = rule.minRule;
    dto.maxRule = rule.maxRule;
    dto.maxPrice = rule.maxPrice;

    if (rule.values.conditionId) {
      dto.conditionId = rule.values.conditionId.map(cd => cd.id);
    } else if ( rule.values['cardConditionId']){
      dto.conditionId = rule.values['cardConditionId'].map(cd => cd.id);
    }
    dto.languageId = rule.values.languageId.map( cd => cd.id);
    if ( dto.cardId){
      dto.editions = [];
      dto.editionId = [];
    }else {
      dto.editions = rule.values.editionId;
      dto.editionId = rule.values.editionId.map( cd => cd.id);
    }

    dto.rarityId = rule.values.rarityId.filter(r => r != null).map(r => r.id);
    return dto;


  }

  insert(dto: PriceRuleDetailDTO): Rx.Observable<PriceRule>{
    const me = this;

    const reqDTO = new PriceRuleDetailDTO();
    Object.keys(dto).forEach(key => {
      if (dto[key] == 'null')
      {
        dto[key] = null;

      }

      if (!isNullOrUndefined(dto[key])){
        reqDTO[key] = dto[key];
      }

    });
    return Rx.Observable.create((observer: any) => {
      me.http.post(me._url, reqDTO)
        .map(function (res: Response) {
          const body: DTO = <DTO> res.json();
          const err: Error = me.getError(body);
          if (err) {
            observer.throw(me.handleError(err, ErrorType.SUBMIT));
            return;
          }
          observer.next(me.onAddOrUpdate(body.data || null));
        }).catch(error => observer.throw(me.handleError(error, ErrorType.HTTP))).subscribe();

    });
  }

  save(dto: PriceRuleDetailDTO): Rx.Observable<PriceRule>{
    const me = this;
    const reqDTO = new PriceRuleDetailDTO();
    Object.keys(dto).forEach(key => {
      if (dto[key] == 'null')
      {
        dto[key] = null;
      }

      if (!isNullOrUndefined(dto[key])){
        reqDTO[key] = dto[key];
      }

    });
    return Rx.Observable.create((observer: any) => {
      me.http.put(this._url + '/' + dto.id, reqDTO)
        .map(function (res: Response) {
          const body: DTO = <DTO> res.json();
          const err: Error = me.getError(body);
          if (err) {
            observer.throw(me.handleError(err, ErrorType.SUBMIT));
            return;
          }
          observer.next(me.onAddOrUpdate(body.data || null));
        }).catch(error => observer.throw(me.handleError(error, ErrorType.HTTP))).subscribe();

    });

  }

  saveAll(rules: PriceRule[]){
    const me = this;
    if (rules) rules = rules.map( r => me.fromEntity(r));
    return Rx.Observable.create((observer: any) => {
        me.httpCall('post', me._url + '/list', rules).subscribe(ret => observer.next(ret));
    });
  }

  public fromJson(json): PriceRule {
    const me = this;
    const item: PriceRule = Object.assign(this.getCleanInstance(), json);

    if (item){
      if (!isNullOrUndefined(item.combination)) {
        if (!isNullOrUndefined(item.combination.language)) {
          this.languageService.loadById(item.combination.language.id).subscribe(i => item.combination.language = i);
        }
        if (!isNullOrUndefined(item.combination.condition)) {
          this.cardCondService.loadById(item.combination.condition.id).subscribe(i => item.combination.condition = i);
        }

        if (!isNullOrUndefined(item.combination.holo)) {
          this.holoService.loadById(item.combination.holo.id).subscribe(i => item.combination.holo = i);
        }
      }

      if (!isNullOrUndefined(item.product)){
        item.product = Object.assign(new ProductDetail(), item.product);
      }




      if ( json.rarity ) {
        item.rarity = this.rarityService.fromJson(json.rarity);
        item.rarityId = item.rarity  ? item.rarity.id : null;
      } else if (  !isNullOrUndefined(item.rarityId) ){
        this.rarityService.loadById(item.rarityId).subscribe( ret =>  item.rarity);
      }

      if (item.multipleValue) {
        item.values = JSON.parse(item.multipleValue);
        if (item.values) {
          item.values.editionId = item.values.editionId.map(ed => Object.assign(new Edition(), ed));
          if (item.values.conditionId) {
            item.values.conditionId = item.values.conditionId.map(ed => this.cardCondService.fromJson(ed));
          }else if (item.values['cardConditionId']){
            item.values.conditionId = item.values['cardConditionId'].map(ed => this.cardCondService.fromJson(ed));
          }
          item.values.languageId = item.values.languageId.map(ed => this.languageService.fromJson(ed));
          item.values.rarityId = item.values.rarityId.map( r => {
            if (isNumeric(r)) {
              const rarity: Rarity = this.rarityService.data.find( cr => cr.id ==  r);
              if( rarity ) {
                return rarity;
              }
            }

            return r;
          });

        }
      }
    }
    return item;
  }

  public fromEntity(en: PriceRule): any {
    const json = super.fromEntity(en);
    if (en && en.combination) {
      json.languageId = en.combination.language ? en.combination.language.id : null;
      json.conditionId = en.combination.condition ? en.combination.condition.id : null;
      json.holo = en.combination.holo ? en.combination.holo.id : null;
      json.altered = en.combination.altered;
      json.foil = en.combination.foil;
      json.inked = en.combination.inked;
      json.stamped = en.combination.stamped;
      json.signed = en.combination.signed;
    }
    return json;
  }

  search( filters: {}): Observable<Page<PriceRule>> {
    const me = this;
    const url = me._url ;

    if ( filters){
      filters =  Object.keys(filters)
        .filter(k => !isNullOrUndefined(filters[k]) && 'null' != filters[k] && 'undefined' != filters[k] )
        .reduce((previousValue, k) => {
          previousValue[k] = filters[k];
          return previousValue;
        }, {});
    }

    return Rx.Observable.create((observer: any) => {
      me.loadPage(filters, undefined, me._url ).subscribe(ret => observer.next(ret));
      //me.httpCall('get', url).subscribe(ret => observer.next(me.setItems(<any[]>ret || null)));
    });

  }

  constructor(protected http: HttpService, private cardCondService: CardConditionService, private languageService: LanguageService, private rarityService: RarityService,  private holoService: HoloService  ) {
    super(http);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/price-rule.service.ts